import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import vClickOutside from 'click-outside-vue3'
import { useApplicationStore } from '@/store/modules/applicationModule'
import router from '@/router'
import axios from 'axios' //←追加
import VueAxios from 'vue-axios' //←追加

createApp(App).use(createPinia()).use(vClickOutside).use(router).use(VueAxios, axios).mount('#app')

const ApplicationStore = useApplicationStore()

window.addEventListener('unhandledrejection', (evt: PromiseRejectionEvent) => {
  ApplicationStore.SET_ERROR_DETAIL(evt.reason)
})

// unhandledrejection エラーハンドリングが効いているかテスト
// new Promise((resolve, reject) => {
//   noSuchFunction()
//   reject('hi')
// })
